import { createFileRoute } from '@tanstack/react-router'

import Mapping from 'pages/Mapping'

export const Route = createFileRoute('/mapping')({
  component: Mapping,
})
